import { useEffect, useState } from "react";
import { Star, Quote } from "lucide-react";
import { api } from "../../lib/api";

function initials(name) {
  return (name || "").trim().split(/\s+/).slice(0, 2).map((p) => p[0]?.toUpperCase()).join("");
}

function Stars({ value }) {
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star key={i} size={13} className={i <= value ? "text-[#d4a840] fill-[#d4a840]" : "text-white/20"} />
      ))}
    </div>
  );
}

export function TestimonialsTab() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/admin/testimonials")
      .then((res) => setRows(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="admin-testimonials-tab">
      <div className="mb-8">
        <div className="kb-label mb-3">Client Voices</div>
        <h1 className="font-display text-3xl font-bold text-white">Testimonials</h1>
        <p className="text-white/50 text-sm mt-2">{rows.length} review{rows.length === 1 ? "" : "s"} submitted from the public site.</p>
      </div>

      {!loading && rows.length === 0 ? (
        <div className="kb-glass rounded-2xl py-16 px-6 flex flex-col items-center text-center">
          <div className="h-12 w-12 rounded-xl bg-[#d4a840]/10 border border-[#d4a840]/30 flex items-center justify-center mb-5">
            <Quote size={20} className="text-[#d4a840]" />
          </div>
          <h3 className="font-display text-xl font-semibold text-white">No reviews yet</h3>
          <p className="mt-2 text-white/50 text-sm">Reviews submitted from the homepage will appear here.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {rows.map((t) => (
            <div key={t.id} className="kb-glass rounded-2xl p-6" data-testid={`admin-testimonial-${t.id}`}>
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className="h-9 w-9 rounded-full bg-[#d4a840]/15 border border-[#d4a840]/40 flex items-center justify-center text-xs font-semibold text-[#d4a840] shrink-0">
                    {initials(t.name)}
                  </div>
                  <div className="leading-tight">
                    <div className="text-sm font-semibold text-white">{t.name}</div>
                    {t.company ? <div className="text-xs text-white/50">{t.company}</div> : null}
                  </div>
                </div>
                <Stars value={t.rating} />
              </div>
              <p className="text-sm text-white/70 leading-relaxed">"{t.message}"</p>
              <div className="mt-4 text-xs text-white/40">
                {new Date(t.created_at).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
